import React, { useEffect, useState } from "react";
import { Spin, Typography, Button } from "antd";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import Swal from "sweetalert2";
import { Tabs } from "antd";
import { FaEye } from "react-icons/fa";
import LeadService from "../../services/LeadService";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { services } from "../../constants/Services";

import "./style.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SellDialog from "./SellDialog";
import EarningDetailsDialog from "./EarningDetailsDialog";

const { Text } = Typography;

const Products = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { category_id } = location.state || {};

  useEffect(() => {
    getCategoryDetails();
    fetchProducts();
  }, []);

  const [selectedCategory, setSelectedCategory] = useState();

  const getCategoryDetails = () => {
    const result = services.find((e) => e.id === category_id);
    setSelectedCategory(result ? result : null);
  };

  const [products, setProducts] = useState();

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const result = await LeadService.getProducts(category_id);

      if (!result.success) {
        return Swal.fire("Oops!", result.message || "Failed to fetch", "error");
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        setProducts(data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [sellModalVisible, setSellModalVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleSellClick = (product) => {
    setSelectedProduct(product);
    setSellModalVisible(true);
  };

  const [earningModalVisible, setEarningModalVisible] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);

  const showEarningDetails = (product) => {
    setModalProduct(product);
    setEarningModalVisible(true);
  };

  return (
    <div className="position-relative">
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(255,255,255,0.7)", zIndex: 9999 }}
        >
          <Spin size="large" tip="Loading..." />
        </div>
      )}

      <Header />

      <div className="bg-light py-5 px-3  d-flex align-items-center justify-content-center">
        <div
          className="card  rounded-4 w-100"
          style={{ maxWidth: "1200px", minHeight: "800px" }}
        >
          <div className="card-body p-4">
            <Button
              type="default"
              className="mb-2"
              onClick={() => navigate(-1)}
              style={{ background: "#f0f0f0", borderRadius: "8px" }}
            >
              ← Back
            </Button>

            {/* SELL & EARN Title */}
            <div className="section-title mb-5">
              <span className="line"></span>
              <span className="text">{selectedCategory?.title || ""}</span>
              <span className="line"></span>
            </div>

            <div className="row g-4">
              <div className="row g-4">
                {products?.map((product) => (
                  <div
                    className="col-md-4 mb-4"
                    key={product.id}
                    onClick={() => {
                      navigate("/product-details", {
                        state: {
                          product: product,
                          category_id: category_id,
                        },
                      });
                    }}
                  >
                    <div
                      className="product-card"
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-10px)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      {/* Earn up to at Top */}
                      <div className="d-flex justify-content-center align-items-center mb-3 gap-2">
                        {/* Badge */}
                        <div
                          className="earn-badge"
                          style={{
                            backgroundColor: "#f5f5f5",
                            padding: "5px 10px",
                            borderRadius: "12px",
                            fontWeight: "500",
                            fontSize: "14px",
                          }}
                        >
                          Earn up to{" "}
                          {product.payout_type === "FLAT"
                            ? `₹${(
                                parseFloat(product.amount || 0) +
                                parseFloat(product.bonus_amount || 0)
                              ).toFixed(2)}`
                            : `${(
                                parseFloat(product.amount || 0) +
                                parseFloat(product.bonus_amount || 0)
                              ).toFixed(2)}%`}
                        </div>

                        {/* Info Icon - outside badge */}
                        <InfoCircleOutlined
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent card click
                            showEarningDetails(product);
                          }}
                          style={{
                            fontSize: "16px",
                            backgroundColor: "#e0e0e0",
                            borderRadius: "50%",
                            padding: "3px",
                            cursor: "pointer",
                          }}
                        />
                      </div>

                      {/* Logo in Square Box */}
                      <div className="logo-box">
                        <img src={product.logo} alt={product.name} />
                      </div>

                      {/* Name & Sub-title */}
                      <h5 className="product-title">{product.name}</h5>
                      <p className="product-subtitle">{product.sub_title}</p>

                      <hr />

                      {/* Buttons: View Details & Apply Now */}
                      <div className="d-flex justify-content-between gap-2 mt-2">
                        <Button
                          type="default"
                          size="middle" // or just remove size
                          block
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/product-details", {
                              state: {
                                product: product,
                                category_id: category_id,
                              },
                            });
                          }}
                        >
                          View Details
                        </Button>

                        <Button
                          type="primary"
                          size="middle"
                          block
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSellClick(product);
                          }}
                        >
                          Sell Now
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {selectedProduct && (
        <SellDialog
          open={sellModalVisible}
          onClose={() => setSellModalVisible(false)}
          category_id={category_id}
          product={selectedProduct}
        />
      )}

      <EarningDetailsDialog
        open={earningModalVisible}
        onClose={() => setEarningModalVisible(false)}
        product={modalProduct}
      />
    </div>
  );
};

export default Products;
